import React from 'react';
import {Route, Link, Switch} from 'react-router-dom';
import Home from './Pages/Home';
import Categories from './Pages/Categories';
import Region from './Pages/Region';
import GotoCategory from './Pages/GotoCategory';
// import Search from './Pages/Search'
import Meal from './Pages/Meal'
import './routing.css';

class Routing extends React.Component{
    render(){
        return(
            <div className="container-fluid">
                <div id="navbar" className="row border shadow py-3 bg-light">
                    <div className="col-2 my-auto">
                    <Link className="pagelinks" to='/'><img className="ml-0 ml-lg-5" width="120px" src="/bon-appetit2.png" alt=" " /></Link>
                    </div>
                    <div className="col-10 my-auto h4 text-right font-weight-bold">
                        <span className="mr-5">
                            <Link className="pagelinks" to='/categories'>Categories</Link>
                        </span>
                        <span className="mr-5">
                            <Link className="pagelinks" to='/region'>Region</Link>
                        </span>
                        <span className="mr-2">
                            <input className="" type="text" placeholder="Search"></input>
                        </span>
                        <span className="mr-0 mr-lg-5">
                            <button id="goBtn">Go</button>
                        </span>
                    </div>
                </div>
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/categories" exact component={Categories} />
                    <Route path="/categories/:gotoCategory" exact render={(props) => <GotoCategory data={this.props.gotoCategory} {...props} />} />
                    <Route path="/categories/:gotoCategory/:mealID" render={(props) => <Meal data2={this.props.categoryMeals} {...props} />} />
                    <Route path="/region" exact component={Region} />
                    <Route path="/region/:gotoRegion" exact component={Region} />
                    <Route path="/region/:gotoRegion/:mealID" component={Meal} />
                    <Route path="/:mealID" exact component={Meal} />
                </Switch>
            </div>
        )
    }
}

export default Routing